export default __webpack_public_path__ + "static/logo-e7266453be743f39c544a320687d8edf.png";